(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bst-size-guide-unit-toggle')) {
    class BstSizeGuideUnitToggle extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-unit-button]');
          if (!button) return;

          const unit = button.dataset.unitButton;
          this.dataset.unit = unit;
          this.querySelectorAll('[data-unit-button]').forEach((btn) => {
            const active = btn === button;
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-pressed', active);
          });
        });
      }
    }

    customElements.define('bst-size-guide-unit-toggle', BstSizeGuideUnitToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
